module.exports = __webpack_public_path__ + "static/p10_back-5a082c9163b6a46f53223c9c7d036c9a.jpg";